
import { mapGetters, mapActions } from 'vuex'
import { generateOrderCode } from '../utils/functionGlobais'
export default {
  props: {
    sdagenda: {
      type: Boolean,
      default: false,
    },
    searchProdutosSdAgenda: {
      type: Array,
      default: () => [],
    },
    actionSairDialog: {
      type: Function,
      default: () => {},
    },
    loadingDataTableAgendamento: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loadingAgendamento: false,
      headers: [
        { text: 'Status', value: 'statusAgendamento' },
        { text: 'Produto', value: 'descricao' },
        { text: 'Quantidade', value: 'quantidade' },
      ],
    }
  },
  computed: {
    ...mapGetters('payment-safe2pay', ['allStatusPayment']),
    verifyStatusAgendamento() {
      const isAutorizado = this.allStatusPayment.status
      const dataHoraCriacao = new Date(this.allStatusPayment.dataHoraCriacao)
      const dataCom = new Date('2024-01-01T00:00:04Z')

      return isAutorizado === 'Autorizado' && dataHoraCriacao > dataCom
    },
    produtosSafe2payAndSdagenda() {
      if (!this.allStatusPayment || !this.allStatusPayment.produtos) {
        return []
      }

      this.allStatusPayment.produtos.forEach((produto) => {
        const produtoCorrespondente =
          Array.isArray(this.searchProdutosSdAgenda) &&
          this.searchProdutosSdAgenda.find((d) => d.produto.sku === produto.sku)

        if (produtoCorrespondente) {
          produto.statusAgendamento = 'agendado'
        } else if (produto.sku === '') {
          produto.statusAgendamento = 'sku_ausente'
        } else {
          produto.statusAgendamento = 'novo_agendamento'
        }
      })

      return this.allStatusPayment.produtos
    },
    productRenovacao() {
      const find = this.produtosSafe2payAndSdagenda.find(
        (e) => e.sku === 'RENOVANUVEM'
      )
      return find
    },
  },

  methods: {
    ...mapActions('dataClient', ['adicionarCartClient']),
    Scheduling() {
      this.loadingAgendamento = true
      const produtosSemAgendamento = this.produtosSafe2payAndSdagenda.filter(
        (product) => product.statusAgendamento === 'novo_agendamento'
      )

      const productPedido = produtosSemAgendamento.map((product) => {
        const { statusAgendamento, ...rest } = product
        return {
          id: generateOrderCode(),
          ...rest,
        }
      })
      if (productPedido.length === 0) {
        this.loadingAgendamento = false
        return this.$toast.error('Nenhum agendamento disponivel')
      }
      this.adicionarCartClient(productPedido)
      this.$router.push({
        path: '/agendamento',
        query: {
          idTransacao: this.allStatusPayment.idTransacao,
        },
      })
    },
  },
}
